/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAccuracyRouteImport } from './routes/_app/accuracy'
import { Route as AppLessonsRouteImport } from './routes/_app/lessons'
import { Route as AppMyWorkRouteImport } from './routes/_app/my-work'
import { Route as AppPricesRouteImport } from './routes/_app/prices'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthSetPasswordRouteImport } from './routes/_auth/set-password'
import { Route as ImpersonateTicketRouteImport } from './routes/impersonate.$ticket'
import { Route as AppReviewsIdRouteImport } from './routes/_app/reviews/$id'
import { Route as AppSupportIndexRouteImport } from './routes/_app/support/index'
import { Route as AppSupportMineRouteImport } from './routes/_app/support/mine'
import { Route as AppYardsIndexRouteImport } from './routes/_app/yards/index'
import { Route as AppYardsIdRouteImport } from './routes/_app/yards/$id'
import { Route as AppHelpArticlesIndexRouteImport } from './routes/_app/help/articles/index'
import { Route as AppHelpArticlesIdRouteImport } from './routes/_app/help/articles/$id'
import { Route as AppHelpArticlesNewRouteImport } from './routes/_app/help/articles/new'
import { Route as AppSupportTicketsIdRouteImport } from './routes/_app/support/tickets.$id'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccuracyRoute = AppAccuracyRouteImport.update({
  id: '/accuracy',
  path: '/accuracy',
  getParentRoute: () => AppRoute,
} as any)
const AppLessonsRoute = AppLessonsRouteImport.update({
  id: '/lessons',
  path: '/lessons',
  getParentRoute: () => AppRoute,
} as any)
const AppMyWorkRoute = AppMyWorkRouteImport.update({
  id: '/my-work',
  path: '/my-work',
  getParentRoute: () => AppRoute,
} as any)
const AppPricesRoute = AppPricesRouteImport.update({
  id: '/prices',
  path: '/prices',
  getParentRoute: () => AppRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSetPasswordRoute = AuthSetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => AuthRoute,
} as any)
const ImpersonateTicketRoute = ImpersonateTicketRouteImport.update({
  id: '/impersonate/$ticket',
  path: '/impersonate/$ticket',
  getParentRoute: () => rootRouteImport,
} as any)
const AppReviewsIdRoute = AppReviewsIdRouteImport.update({
  id: '/reviews/$id',
  path: '/reviews/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportIndexRoute = AppSupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportMineRoute = AppSupportMineRouteImport.update({
  id: '/support/mine',
  path: '/support/mine',
  getParentRoute: () => AppRoute,
} as any)
const AppYardsIndexRoute = AppYardsIndexRouteImport.update({
  id: '/yards/',
  path: '/yards/',
  getParentRoute: () => AppRoute,
} as any)
const AppYardsIdRoute = AppYardsIdRouteImport.update({
  id: '/yards/$id',
  path: '/yards/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpArticlesIndexRoute = AppHelpArticlesIndexRouteImport.update({
  id: '/help/articles/',
  path: '/help/articles/',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpArticlesIdRoute = AppHelpArticlesIdRouteImport.update({
  id: '/help/articles/$id',
  path: '/help/articles/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpArticlesNewRoute = AppHelpArticlesNewRouteImport.update({
  id: '/help/articles/new',
  path: '/help/articles/new',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportTicketsIdRoute = AppSupportTicketsIdRouteImport.update({
  id: '/support/tickets/$id',
  path: '/support/tickets/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/accuracy': typeof AppAccuracyRoute
  '/lessons': typeof AppLessonsRoute
  '/my-work': typeof AppMyWorkRoute
  '/prices': typeof AppPricesRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/set-password': typeof AuthSetPasswordRoute
  '/impersonate/$ticket': typeof ImpersonateTicketRoute
  '/reviews/$id': typeof AppReviewsIdRoute
  '/support/mine': typeof AppSupportMineRoute
  '/yards/$id': typeof AppYardsIdRoute
  '/support/': typeof AppSupportIndexRoute
  '/yards/': typeof AppYardsIndexRoute
  '/help/articles/$id': typeof AppHelpArticlesIdRoute
  '/help/articles/new': typeof AppHelpArticlesNewRoute
  '/support/tickets/$id': typeof AppSupportTicketsIdRoute
  '/help/articles/': typeof AppHelpArticlesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/accuracy': typeof AppAccuracyRoute
  '/lessons': typeof AppLessonsRoute
  '/my-work': typeof AppMyWorkRoute
  '/prices': typeof AppPricesRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/set-password': typeof AuthSetPasswordRoute
  '/impersonate/$ticket': typeof ImpersonateTicketRoute
  '/reviews/$id': typeof AppReviewsIdRoute
  '/support/mine': typeof AppSupportMineRoute
  '/yards/$id': typeof AppYardsIdRoute
  '/support': typeof AppSupportIndexRoute
  '/yards': typeof AppYardsIndexRoute
  '/help/articles/$id': typeof AppHelpArticlesIdRoute
  '/help/articles/new': typeof AppHelpArticlesNewRoute
  '/support/tickets/$id': typeof AppSupportTicketsIdRoute
  '/help/articles': typeof AppHelpArticlesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_app/accuracy': typeof AppAccuracyRoute
  '/_app/lessons': typeof AppLessonsRoute
  '/_app/my-work': typeof AppMyWorkRoute
  '/_app/prices': typeof AppPricesRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/set-password': typeof AuthSetPasswordRoute
  '/impersonate/$ticket': typeof ImpersonateTicketRoute
  '/_app/': typeof AppIndexRoute
  '/_app/reviews/$id': typeof AppReviewsIdRoute
  '/_app/support/mine': typeof AppSupportMineRoute
  '/_app/yards/$id': typeof AppYardsIdRoute
  '/_app/support/': typeof AppSupportIndexRoute
  '/_app/yards/': typeof AppYardsIndexRoute
  '/_app/help/articles/$id': typeof AppHelpArticlesIdRoute
  '/_app/help/articles/new': typeof AppHelpArticlesNewRoute
  '/_app/support/tickets/$id': typeof AppSupportTicketsIdRoute
  '/_app/help/articles/': typeof AppHelpArticlesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accuracy'
    | '/lessons'
    | '/my-work'
    | '/prices'
    | '/forgot-password'
    | '/login'
    | '/set-password'
    | '/impersonate/$ticket'
    | '/reviews/$id'
    | '/support/mine'
    | '/yards/$id'
    | '/support/'
    | '/yards/'
    | '/help/articles/$id'
    | '/help/articles/new'
    | '/support/tickets/$id'
    | '/help/articles/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accuracy'
    | '/lessons'
    | '/my-work'
    | '/prices'
    | '/forgot-password'
    | '/login'
    | '/set-password'
    | '/impersonate/$ticket'
    | '/reviews/$id'
    | '/support/mine'
    | '/yards/$id'
    | '/support'
    | '/yards'
    | '/help/articles/$id'
    | '/help/articles/new'
    | '/support/tickets/$id'
    | '/help/articles'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/_app/accuracy'
    | '/_app/lessons'
    | '/_app/my-work'
    | '/_app/prices'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/set-password'
    | '/impersonate/$ticket'
    | '/_app/'
    | '/_app/reviews/$id'
    | '/_app/support/mine'
    | '/_app/yards/$id'
    | '/_app/support/'
    | '/_app/yards/'
    | '/_app/help/articles/$id'
    | '/_app/help/articles/new'
    | '/_app/support/tickets/$id'
    | '/_app/help/articles/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  ImpersonateTicketRoute: typeof ImpersonateTicketRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accuracy': {
      id: '/_app/accuracy'
      path: '/accuracy'
      fullPath: '/accuracy'
      preLoaderRoute: typeof AppAccuracyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lessons': {
      id: '/_app/lessons'
      path: '/lessons'
      fullPath: '/lessons'
      preLoaderRoute: typeof AppLessonsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-work': {
      id: '/_app/my-work'
      path: '/my-work'
      fullPath: '/my-work'
      preLoaderRoute: typeof AppMyWorkRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/prices': {
      id: '/_app/prices'
      path: '/prices'
      fullPath: '/prices'
      preLoaderRoute: typeof AppPricesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/set-password': {
      id: '/_auth/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof AuthSetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/impersonate/$ticket': {
      id: '/impersonate/$ticket'
      path: '/impersonate/$ticket'
      fullPath: '/impersonate/$ticket'
      preLoaderRoute: typeof ImpersonateTicketRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/reviews/$id': {
      id: '/_app/reviews/$id'
      path: '/reviews/$id'
      fullPath: '/reviews/$id'
      preLoaderRoute: typeof AppReviewsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support/': {
      id: '/_app/support/'
      path: '/support'
      fullPath: '/support/'
      preLoaderRoute: typeof AppSupportIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support/mine': {
      id: '/_app/support/mine'
      path: '/support/mine'
      fullPath: '/support/mine'
      preLoaderRoute: typeof AppSupportMineRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/yards/': {
      id: '/_app/yards/'
      path: '/yards'
      fullPath: '/yards/'
      preLoaderRoute: typeof AppYardsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/yards/$id': {
      id: '/_app/yards/$id'
      path: '/yards/$id'
      fullPath: '/yards/$id'
      preLoaderRoute: typeof AppYardsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/articles/': {
      id: '/_app/help/articles/'
      path: '/help/articles'
      fullPath: '/help/articles/'
      preLoaderRoute: typeof AppHelpArticlesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/articles/$id': {
      id: '/_app/help/articles/$id'
      path: '/help/articles/$id'
      fullPath: '/help/articles/$id'
      preLoaderRoute: typeof AppHelpArticlesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/articles/new': {
      id: '/_app/help/articles/new'
      path: '/help/articles/new'
      fullPath: '/help/articles/new'
      preLoaderRoute: typeof AppHelpArticlesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support/tickets/$id': {
      id: '/_app/support/tickets/$id'
      path: '/support/tickets/$id'
      fullPath: '/support/tickets/$id'
      preLoaderRoute: typeof AppSupportTicketsIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAccuracyRoute: typeof AppAccuracyRoute
  AppLessonsRoute: typeof AppLessonsRoute
  AppMyWorkRoute: typeof AppMyWorkRoute
  AppPricesRoute: typeof AppPricesRoute
  AppIndexRoute: typeof AppIndexRoute
  AppReviewsIdRoute: typeof AppReviewsIdRoute
  AppSupportMineRoute: typeof AppSupportMineRoute
  AppYardsIdRoute: typeof AppYardsIdRoute
  AppSupportIndexRoute: typeof AppSupportIndexRoute
  AppYardsIndexRoute: typeof AppYardsIndexRoute
  AppHelpArticlesIdRoute: typeof AppHelpArticlesIdRoute
  AppHelpArticlesNewRoute: typeof AppHelpArticlesNewRoute
  AppSupportTicketsIdRoute: typeof AppSupportTicketsIdRoute
  AppHelpArticlesIndexRoute: typeof AppHelpArticlesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccuracyRoute: AppAccuracyRoute,
  AppLessonsRoute: AppLessonsRoute,
  AppMyWorkRoute: AppMyWorkRoute,
  AppPricesRoute: AppPricesRoute,
  AppIndexRoute: AppIndexRoute,
  AppReviewsIdRoute: AppReviewsIdRoute,
  AppSupportMineRoute: AppSupportMineRoute,
  AppYardsIdRoute: AppYardsIdRoute,
  AppSupportIndexRoute: AppSupportIndexRoute,
  AppYardsIndexRoute: AppYardsIndexRoute,
  AppHelpArticlesIdRoute: AppHelpArticlesIdRoute,
  AppHelpArticlesNewRoute: AppHelpArticlesNewRoute,
  AppSupportTicketsIdRoute: AppSupportTicketsIdRoute,
  AppHelpArticlesIndexRoute: AppHelpArticlesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthSetPasswordRoute: typeof AuthSetPasswordRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthSetPasswordRoute: AuthSetPasswordRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  ImpersonateTicketRoute: ImpersonateTicketRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
